type Style = {
  locals?: object;
};

export const extractStyle = (style: Style): any => {
  const isSSR = typeof window !== undefined;
  if (isSSR && style.hasOwnProperty('locals') && style.locals) {
    return { ...style, ...style.locals };
  }
  return style;
};
